export default __webpack_public_path__ + "img/app_store-bb1b42aa11cd969766e425965b190de9.png";